/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { PostPipeSeriesOptions, PostPipeSeriesResponses } from '../types/PostPipeSeries'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /pipe-series/}
 */
export function postPipeSeries<ThrowOnError extends boolean = true>(options: Options<PostPipeSeriesOptions, ThrowOnError>): Unwrappable<RequestResult<PostPipeSeriesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'POST', url: '/pipe-series/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<PostPipeSeriesResponses, ThrowOnError>>)
}
